import { get } from 'lodash';
import { nativeExtensionsList } from '../constants';
import { AvailableFor } from '../../marketplace-admin/constants';
export const isNativeAvailableForProAndClinic = (extension, user, institution) => !Boolean(extension.isInstalled) &&
    nativeExtensionsList.includes(extension.name) &&
    extension.availableFor === AvailableFor.PRO_CLINIC &&
    user.subscriptionType !== 'free' &&
    !Boolean(institution);
export const sortByTitle = (a, b) => {
    const titleA = a.title.toLowerCase();
    const titleB = b.title.toLowerCase();
    if (titleA < titleB) {
        return -1;
    }
    if (titleA > titleB) {
        return 1;
    }
    return 0;
};
export const isAngularExtensionInstalled = (institution, extension) => {
    return get(institution, `institutionAccess.extensions_${extension.name}`);
};
export function filterAvailableExtensions(extensions, user, institution) {
    const availableFilter = (extension) => {
        return (!Boolean(isNativeAvailableForProAndClinic(extension, user, institution)) &&
            !Boolean(extension.isInstalled) &&
            !Boolean(isAngularExtensionInstalled(institution, extension)));
    };
    return extensions.filter((extension) => availableFilter(extension));
}
export function filterInstalledExtensions(extensions, user, institution) {
    const installedFilter = (extension) => {
        return (Boolean(extension.isInstalled) ||
            Boolean(isAngularExtensionInstalled(institution, extension)) ||
            isNativeAvailableForProAndClinic(extension, user, institution));
    };
    return extensions.filter((extension) => installedFilter(extension));
}
export function filterHasNewExtensions(extensions) {
    const suitableForNewBadgeFilter = (ext) => {
        return !nativeExtensionsList.includes(ext.name) && ext.isNew;
    };
    const filtered = extensions.filter((extension) => suitableForNewBadgeFilter(extension));
    return filtered.length > 0;
}
